<template>
	<div class="advert-manage-container">
		<div style="margin-bottom: 20px">
			<!-- 标签页 -->
			<el-button-group>
				<el-button
					v-for="tab in tabs"
					:key="tab.name"
					:type="activeTab === tab.name ? 'primary' : ''"
					size="small"
					@click="tabClick(tab.name)">
					{{ tab.label }}
				</el-button>
			</el-button-group>
		</div>
		<InfoCards :data="currentStats" />
		<!-- 搜索条件 -->
		<QueryCard @search="handleSearch" @reset="handleReset">
			<template slot="base">
				<!-- 交易日期 -->
				<el-col :span="6">
					<el-date-picker
						v-model="query.tradeDateRange"
						type="daterange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						value-format="yyyy-MM-dd"
						style="width: 100%" />
				</el-col>

				<!-- 状态 -->
				<el-col :span="6">
					<el-select v-model="query.status" placeholder="请选择状态" style="width: 100%">
						<el-option label="待析账" value="待析账" />
						<el-option label="析账失败" value="析账失败" />
						<el-option label="待销账" value="待销账" />
						<el-option label="已销账" value="已销账" />
						<el-option label="销账失败" value="销账失败" />
					</el-select>
				</el-col>
				<!-- 合同编号 -->
				<el-col :span="6">
					<el-input v-model="query.contractNo" placeholder="请输入合同编号" />
				</el-col>
			</template>
			<template slot="more">
				<!-- 资源名称 -->
				<el-col :span="6">
					<el-input v-model="query.resourceName" placeholder="请输入资源" />
				</el-col>
			</template>
		</QueryCard>
		<!-- 表格 -->
		<BaseTable
			:key="activeTab"
			:actions="{
				export: true,
			}"
			:selection="false"
			:loading="loading"
			:data="tableData"
			:columns="currentTable"
			:total="total"
			:pageNum="query.pageNum"
			:pageSize="query.pageSize"
			@page-change="pageChange"
			@size-change="sizeChange"
			@export="handleExport"></BaseTable>
	</div>
</template>

<script>
	export default {
		name: 'ExpenseLedger',
		data() {
			return {
				activeTab: '1',
				tabs: [
					{ name: '1', label: '应付台账' },
					{ name: '2', label: '应收台账' },
					{ name: '3', label: '保证金台账' },
					{ name: '4', label: '意向金台账' },
					{ name: '5', label: '减免台账' },
				],
				statsMap: {
					1: [
						{ label: '本月待付金额', value: '45,872.68', color: '#ff4d4f' },
						{ label: '本月实付金额', value: '1,177.72', color: '#52c41a' },
						{ label: '本月减免金额', value: '999.31', color: '#faad14' },
						{ label: '本月应付金额', value: '44,872.65', color: '#1890ff' },
					],

					2: [
						{ label: '本月应收金额', value: '12,456.00', color: '#1890ff' },
						{ label: '本月实收金额', value: '8,234.00', color: '#52c41a' },
						{ label: '本月待收金额', value: '4,222.00', color: '#ff4d4f' },
						{ label: '本月减免金额', value: '0.00', color: '#faad14' },
					],

					3: [
						{ label: '保证金总额', value: '850,000.00', color: '#1890ff' },
						{ label: '本月已收金额', value: '850,000.00', color: '#52c41a' },
						{ label: '本月已退金额', value: '20,000.00', color: '#ff4d4f' },
						{ label: '在押金额', value: '830,000.00', color: '#722ed1' },
					],

					4: [
						{ label: '意向金总额', value: '23,000.00', color: '#1890ff' },
						{ label: '本月结转合同', value: '10,000.00', color: '#52c41a' },
						{ label: '本月已退款', value: '5,000.00', color: '#ff4d4f' },
						{ label: '待处理', value: '8,000.00', color: '#faad14' },
					],

					5: [
						{ label: '减免总额', value: '2,063.87', color: '#1890ff' },
						{ label: '本月已审批', value: '563.87', color: '#52c41a' },
						{ label: '待审批', value: '1,500.00', color: '#ff4d4f' },
						{ label: '涉及合同', value: '3', color: '#722ed1' },
					],
				},
				loading: false,
				total: 0,
				query: {
					tradeDateRange: [], // 交易日期
					status: '', // 状态（你原来写 planType 是错的）
					contractNo: '', // 合同编号
					resourceName: '', // 资源
					pageNum: 1,
					pageSize: 10,
				},
				tableConfig: {
					1: [
						{ prop: 'feeType', label: '费用类型' },
						{ prop: 'period', label: '费用期间' },
						{ prop: 'contractNo', label: '合同编号' },
						{ prop: 'resource', label: '资源' },
						{ prop: 'deadline', label: '付款截止日期' },
						{ prop: 'status', label: '状态' },
						{ prop: 'payable', label: '应付金额(元)' },
						{ prop: 'paid', label: '实付金额(元)' },
						{ prop: 'reduced', label: '减免金额(元)' },
						{ prop: 'counterparty', label: '收款方' },
						{ prop: 'source', label: '来源单据' },
						{ prop: 'creator', label: '创建人' },
						{ prop: 'handler', label: '经办人' },
					],

					2: [
						{ prop: 'feeType', label: '费用类型' },
						{ prop: 'period', label: '费用期间' },
						{ prop: 'contractNo', label: '合同编号' },
						{ prop: 'resource', label: '资源' },
						{ prop: 'dueDate', label: '缴费截止日期' },
						{ prop: 'status', label: '状态' },
						{ prop: 'receivable', label: '应收金额(元)' },
						{ prop: 'received', label: '实收金额(元)' },
						{ prop: 'reduced', label: '减免金额(元)' },
						{ prop: 'payer', label: '付款方' },
						{ prop: 'source', label: '来源单据' },
						{ prop: 'creator', label: '创建人' },
						{ prop: 'handler', label: '经办人' },
					],

					3: [
						{ prop: 'depositType', label: '保证金类型' },
						{ prop: 'contractNo', label: '合同编号' },
						{ prop: 'resource', label: '资源' },
						{ prop: 'amount', label: '金额(元)' },
						{ prop: 'status', label: '状态' },
						{ prop: 'receiveDate', label: '收款日期' },
						{ prop: 'refundDate', label: '退款日期' },
						{ prop: 'payer', label: '付款方' },
						{ prop: 'creator', label: '创建人' },
						{ prop: 'remark', label: '备注' },
					],

					4: [
						{ prop: 'intentNo', label: '意向金编号' },
						{ prop: 'customerName', label: '客户名称' },
						{ prop: 'resource', label: '意向资源' },
						{ prop: 'amount', label: '金额(元)' },
						{ prop: 'status', label: '状态' },
						{ prop: 'receiveDate', label: '收款日期' },
						{ prop: 'convertDate', label: '转合同日期' },
						{ prop: 'refundDate', label: '退款日期' },
						{ prop: 'creator', label: '创建人' },
						{ prop: 'remark', label: '备注' },
					],

					5: [
						{ prop: 'feeType', label: '费用类型' },
						{ prop: 'period', label: '费用期间' },
						{ prop: 'contractNo', label: '合同编号' },
						{ prop: 'resource', label: '资源' },
						{ prop: 'originalAmount', label: '原金额(元)' },
						{ prop: 'discountAmount', label: '减免金额(元)' },
						{ prop: 'actualAmount', label: '实收金额(元)' },
						{ prop: 'reason', label: '减免原因' },
						{ prop: 'approver', label: '审批人' },
						{ prop: 'status', label: '审批状态' },
						{ prop: 'createDate', label: '创建日期' },
					],
				},
				tableData: [],
			};
		},
		computed: {
			currentStats() {
				return this.statsMap[this.activeTab] || [];
			},
			currentTable() {
				return this.tableConfig[this.activeTab] || [];
			},
		},
		created() {
			const data = this.getTableData(this.activeTab );
			this.tableData = data;
		},
		methods: {
			tabClick(name) {
				this.activeTab = name;
				const data = this.getTableData(name);
				this.tableData = data;
			},
			handleSearch() {},
			handleReset() {
				this.query = {
					tradeDateRange: [], // 交易日期
					status: '', // 状态（你原来写 planType 是错的）
					contractNo: '', // 合同编号
					resourceName: '', // 资源
					pageNum: 1,
					pageSize: 10,
				};
			},
			pageChange(page) {
				this.query.pageNum = page;
			},
			sizeChange(size) {
				this.query.pageSize = size;
			},
			handleExport() {},
			getTableData(tab) {
				const dataMap = {
					1: [
						{
							feeType: '绿化养护',
							period: '2024-06-01 至 2024-06-30',
							contractNo: 'CGBH-2024-001',
							resource: '园区绿化区域A',
							deadline: '2024-06-05',
							status: '待支付',
							payable: 15000,
							paid: 0,
							reduced: 0,
							counterparty: '绿城园林公司',
							source: '采购合同',
							creator: '何知伟',
							handler: '何知伟',
						},
					],

					2: [
						{
							feeType: '物业管理费',
							period: '2024-06-01 至 2024-06-30',
							contractNo: 'WY-2024-001',
							resource: 'A栋101',
							dueDate: '2024-06-10',
							status: '已收款',
							receivable: 5000,
							received: 5000,
							reduced: 0,
							payer: '张三',
							source: '物业公司',
							creator: '李四',
							handler: '李四',
						},
					],

					3: [
						{
							depositType: '租赁保证金',
							contractNo: 'GHWH-2024-001',
							resource: '一期1栋11层1101',
							amount: 60000,
							status: '已收',
							receiveDate: '2024-01-15',
							refundDate: '-',
							payer: 'GH上海股份有限公司',
							creator: '何知伟',
							remark: '合同保证金',
						},
					],

					4: [
						{
							intentNo: 'YXJ-2024-001',
							customerName: 'ABC科技有限公司',
							resource: '一期1栋12层1201',
							amount: 10000,
							status: '已转合同',
							receiveDate: '2024-01-10',
							convertDate: '2024-01-20',
							refundDate: '',
							creator: '张三',
							remark: '已转为租赁保证金',
						},
					],

					5: [
						{
							feeType: '固定租金',
							period: '2024-06-01 至 2024-06-30',
							contractNo: 'GHWH-2024-001',
							resource: '一期1栋11层1101',
							originalAmount: 200,
							discountAmount: 63.87,
							actualAmount: 136.13,
							reason: '疫情减免',
							approver: '总经理',
							status: '已审批',
							createDate: '2024-06-05',
						},
					],
				};

				return dataMap[tab] || [];
			},
		},
	};
</script>

<style scoped lang="scss">
	.advert-manage-container {
		padding: 20px;
		color: #1c1c1c;
		text-align: left;
	}
</style>
